module.exports = __webpack_public_path__ + "static/img/img_cabinet.1202c6cc.png";